import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTickIconProps {
  fillColor: any;
}

/**
 * Component diaplays pin control icon
 * @param props -CcfTickIconProps
 * @returns pin control svg icon
 * @example <CcfTickIcon/>
 */
export function CcfTickIcon(props: CcfTickIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.9568 4.31579C18.5332 3.89474 17.8979 3.89474 17.4744 4.31579L8.15677 13.5789L3.07441 8.73684C2.65088 8.31579 2.01559 8.31579 1.59206 8.73684C1.16853 9.15789 1.16853 9.78947 1.59206 10.2105L7.52147 15.6842C7.73324 15.8947 7.945 16 8.26265 16C8.5803 16 8.79206 15.8947 9.00383 15.6842L18.9568 5.78947C19.3803 5.36842 19.3803 4.73684 18.9568 4.31579Z"
          fill={props?.fillColor ? props?.fillColor : '#278A35'}
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfTickIcon;
